/*
 * ANAR Designer – Personalisierung von T-Shirts und Babybodys (Dawn-Theme)
 * Motive überall auf Vorder-/Rückseite und Ärmeln, Preis pro Druck,
 * Druckdateien (PNG, transparent, 300 DPI) werden als Line-Item-Properties hochgeladen.
 */
(function () {
  'use strict';

  const SMALL_MAX_CM = 15;      // längste Seite bis 15 cm = kleiner Druck
  const UNITS_SMALL = 1;        // × Preis des Aufpreis-Produkts (5 €)
  const UNITS_LARGE = 2;        // = 10 €
  const GROUP_GAP_CM = 3;       // Motive näher als 3 cm = ein gemeinsamer Druck
  const W = 500, H = 560;
  const ACCENT = '#D52F68';
  const PHOTO_VERSION = '4'; // bump when the mockup photos change (cache busting)

  // Produktfotos (Assets anar-mock-<produkt>-<ansicht>-<farbe>.jpg + Maske anar-mask-<produkt>-<ansicht>.png),
  // 1000×1120 px = Leinwand 500×560. Werte aus tools/process.js (T-Shirt M 52 × 72 cm, Body 23 cm breit).
  // region = bedruckbare Fläche (Bounding Box der Maske), refY/midX = Bezug für die Positionsangabe.
  const PHOTO = {
    tshirt: {
      colors: ['schwarz', 'weiss'],
      maxCm: { w: 35, h: 45 },
      // Front/back = real model photos (print erased, recoloured for weiß), values from ref/tee/tee.js + back.js
      front: { region: [31, 129, 442, 415.5], pxPerCm: 5.639, refY: 173, midX: 254.5 },
      back: { region: [36, 84.5, 423.5, 454.5], pxPerCm: 4.648, refY: 84.5, midX: 250 },
      // „links“ = beim Tragen links = auf dem Frontfoto rechts
      sleeves: { left: [401.5, 179.5, 71.5, 178], right: [31.5, 182.5, 76, 175] }
    },
    hoodie: {
      colors: ['schwarz', 'weiss'],
      maxCm: { w: 35, h: 42 },
      // real model photos (print erased, recoloured for weiß), values from ref/hood/hood.js (chest M ≈ 58 cm)
      front: { region: [57.5, 47, 381, 424], pxPerCm: 4.226, refY: 122.5, midX: 252 },
      back: { region: [39, 30.5, 410.5, 426], pxPerCm: 4.072, refY: 107, midX: 247.5 },
      sleeves: { left: [375, 122, 63.5, 274.5], right: [57.5, 117, 71.5, 354.5] }
    },
    body: {
      colors: ['weiss', 'blau', 'rosa', 'rot', 'schwarz'],
      maxCm: { w: 14, h: 16 },
      // Front = real baby photo (blank body cut out of the ANAR product photo, recoloured per colour)
      front: { region: [118.5, 166, 266, 359], pxPerCm: 8.718, refY: 198, midX: 256.5 },
      back: { region: [36, 28.5, 428.5, 503.5], pxPerCm: 11.804, refY: 48.5, midX: 250.5 },
      sleeves: { left: [335, 175, 49, 98], right: [118.5, 182, 47, 95] }
    }
  };
  function buildZones(g) {
    const P = PHOTO[g];
    const zones = ['front', 'back'].map(v => ({
      id: v, label: v === 'front' ? 'Vorne' : 'Hinten', img: v, zoom: 1, cx: W / 2, cy: H / 2,
      region: P[v].region, pxPerCm: P[v].pxPerCm, refY: P[v].refY, midX: P[v].midX,
      maxCm: P.maxCm, refLabel: 'Kragen'
    }));
    [['sleeveL', 'Ärmel links', P.sleeves.left], ['sleeveR', 'Ärmel rechts', P.sleeves.right]].forEach(([id, label, b]) => {
      // Ärmel = vergrößerter Ausschnitt des Frontfotos
      const zoom = Math.min(W * 0.78 / b[2], H * 0.78 / b[3]);
      const cx = b[0] + b[2] / 2, cy = b[1] + b[3] / 2;
      const tx = x => W / 2 + (x - cx) * zoom, ty = y => H / 2 + (y - cy) * zoom;
      zones.push({
        id, label, img: 'front', zoom, cx, cy,
        region: [tx(b[0]), ty(b[1]), b[2] * zoom, b[3] * zoom],
        pxPerCm: P.front.pxPerCm * zoom, refY: ty(b[1]), midX: W / 2,
        maxCm: null, refLabel: 'Schulternaht'
      });
    });
    return zones;
  }
  // Variantenname -> Dateiname der Farbe
  const COLOR_FILE = { white: 'weiss', black: 'schwarz', pink: 'rosa', blue: 'blau', babyblau: 'blau', red: 'rot' };
  function colorFileKey(g, name) {
    let k = String(name || '').trim().toLowerCase().replace(/ß/g, 'ss').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue');
    k = COLOR_FILE[k] || k;
    return PHOTO[g].colors.includes(k) ? k : PHOTO[g].colors[0];
  }

  const FONTS = {
    'Montserrat': 800, 'Bebas Neue': 400, 'Anton': 400, 'Pacifico': 400, 'Lobster': 400,
    'Permanent Marker': 400, 'Caveat': 700, 'Playfair Display': 700, 'Fredoka': 600
  };
  const TEXT_COLORS = [
    ['Schwarz', '#111111'], ['Weiß', '#FFFFFF'], ['Rot', '#D7263D'], ['Rosa', '#F49AC2'], ['Babyblau', '#8EC5FF'],
    ['Königsblau', '#1F4FD8'], ['Grün', '#1E9E5A'], ['Gelb', '#FFD23F'], ['Orange', '#FF8C1A'], ['Gold', '#C9A227'], ['Lila', '#7A4FD0'], ['Grau', '#8A8D93']
  ];
  // Stofffarben aus den Varianten-Namen
  const GARMENT_COLORS = {
    schwarz: ['#1F1F22', true], black: ['#1F1F22', true],
    'weiß': ['#F8F8F6', false], weiss: ['#F8F8F6', false], white: ['#F8F8F6', false],
    blau: ['#A8C7E6', false], blue: ['#A8C7E6', false], babyblau: ['#A8C7E6', false],
    rosa: ['#F3C1CF', false], pink: ['#F3C1CF', false],
    rot: ['#C4313B', true], red: ['#C4313B', true],
    grau: ['#9A9DA3', false], grey: ['#9A9DA3', false], gray: ['#9A9DA3', false],
    navy: ['#1F2A44', true], 'grün': ['#4C7A4C', true], green: ['#4C7A4C', true],
    gelb: ['#F4D35E', false], beige: ['#E6D7BE', false]
  };
  function garmentColor(name) {
    const hit = GARMENT_COLORS[String(name || '').trim().toLowerCase()];
    return hit ? { n: name, h: hit[0], dark: hit[1] } : { n: name, h: '#E4E4E4', dark: false };
  }


  // Sharp photos on screen: the canvas shows a high-quality downscaled copy (stepwise halving),
  // the print export swaps the original back in.
  const DISPLAY_MAX = 1600;
  function displayCopy(el) {
    const w0 = el.naturalWidth || el.width, h0 = el.naturalHeight || el.height;
    const f = Math.min(1, DISPLAY_MAX / Math.max(w0, h0));
    if (f >= 1) return null;
    const tw = Math.round(w0 * f), th = Math.round(h0 * f);
    let src = el, w = w0, h = h0;
    const draw = (cw, ch) => {
      const cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
      const x = cv.getContext('2d'); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(src, 0, 0, cw, ch); return cv;
    };
    while (w / 2 >= tw) { src = draw(Math.round(w / 2), Math.round(h / 2)); w = src.width; h = src.height; }
    return draw(tw, th);
  }
  function useDisplayCopy(img) {
    const full = img.getElement(), copy = displayCopy(full);
    if (!copy) return;
    img._anarFull = full;
    img._anarRatio = (full.naturalWidth || full.width) / copy.width;
    img.setElement(copy);
  }
  function withFullRes(c, fn) {
    const swapped = [];
    c.getObjects().forEach(o => {
      if (!o._anarFull) return;
      const disp = o.getElement(), sx = o.scaleX, sy = o.scaleY;
      o.setElement(o._anarFull); o.set({ scaleX: sx / o._anarRatio, scaleY: sy / o._anarRatio });
      swapped.push([o, disp, sx, sy]);
    });
    try { return fn(); } finally {
      swapped.forEach(([o, disp, sx, sy]) => { o.setElement(disp); o.set({ scaleX: sx, scaleY: sy }); o.setCoords(); o.dirty = true; });
    }
  }

  const cm1 = n => n.toFixed(1).replace('.', ',');
  const isTouch = window.matchMedia('(pointer: coarse)').matches;

  async function initDesigner(root) {
    if (!window.fabric) {
      root.querySelector('[data-el="stage"]').innerHTML = '<p class="anar-hint" style="padding:40px">Der Editor konnte nicht geladen werden. Bitte Seite neu laden.</p>';
      return;
    }
    if (!fabric.Image.prototype.__anarHQ) {
      // browsers default to low-quality scaling; photos look soft/jagged without this
      const renderFill = fabric.Image.prototype._renderFill;
      fabric.Image.prototype._renderFill = function (ctx) { ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high'; return renderFill.call(this, ctx); };
      // draw the cached photo on whole device pixels (half-pixel positions make it look soft)
      fabric.Image.prototype.drawCacheOnCanvas = function (ctx) {
        ctx.scale(1 / this.zoomX, 1 / this.zoomY);
        const m = ctx.getTransform();
        if (m.a > 0 && Math.abs(m.b) < 1e-6 && Math.abs(m.c) < 1e-6 && Math.abs(m.a - m.d) < 1e-6 && Math.abs(m.a - 1) < 1e-3) {
          const x = m.e - this.cacheTranslationX * m.a, y = m.f - this.cacheTranslationY * m.d;
          ctx.setTransform(1, 0, 0, 1, Math.round(x), Math.round(y));
          ctx.drawImage(this._cacheCanvas, 0, 0);
        } else {
          ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
        }
      };
      fabric.Image.prototype.__anarHQ = true;
    }
    const cfg = JSON.parse(root.querySelector('script[data-anar-config]').textContent);
    const gKey = PHOTO[cfg.garment] ? cfg.garment : 'tshirt';
    const ZONES = buildZones(gKey);
    const q = name => root.querySelector(`[data-el="${name}"]`);
    const money = cents => new Intl.NumberFormat(cfg.locale || 'de-DE', { style: 'currency', currency: cfg.currency || 'EUR' }).format(cents / 100);
    const stageEl = q('stage');
    let exporting = false;

    fabric.Object.prototype.set({
      transparentCorners: false, cornerStyle: 'circle', cornerSize: isTouch ? 20 : 12,
      cornerColor: '#ffffff', cornerStrokeColor: ACCENT, borderColor: ACCENT,
      borderScaleFactor: 1.5, padding: 4
    });

    // ---------- Varianten ----------
    const colorIdx = cfg.options.findIndex(o => /farbe|color|colour/i.test(o));
    const sizeIdx = cfg.options.findIndex((o, i) => i !== colorIdx);
    const uniq = idx => idx < 0 ? [] : [...new Set(cfg.variants.map(v => v.options[idx]))];
    const colors = uniq(colorIdx).map(garmentColor);
    const sizes = uniq(sizeIdx);
    const startV = cfg.variants.find(v => v.id === cfg.selectedVariant) || cfg.variants[0];
    const state = {
      zone: 'front',
      color: colorIdx >= 0 ? startV.options[colorIdx] : null,
      size: sizeIdx >= 0 ? startV.options[sizeIdx] : null,
      busy: false
    };
    const colorObj = () => colors.find(c => c.n === state.color) || garmentColor('weiß');
    function currentVariant() {
      return cfg.variants.find(v => (colorIdx < 0 || v.options[colorIdx] === state.color) && (sizeIdx < 0 || v.options[sizeIdx] === state.size));
    }

    // ---------- Editoren (eine Leinwand pro Ansicht) ----------
    const eds = {};
    const cur = () => eds[state.zone].c;

    // Foto (oder Maske) einer Ansicht so platzieren, dass 1000×1120 px auf 500×560 passen; Ärmel vergrößert
    function photoTransform(Z, img) {
      const s = Z.zoom * (W / img.width);
      return { left: W / 2 - Z.cx * Z.zoom, top: H / 2 - Z.cy * Z.zoom, scaleX: s, scaleY: s, originX: 'left', originY: 'top' };
    }
    const loadImage = url => new Promise((res, rej) => fabric.Image.fromURL(url, img => (img && img.width ? res(img) : rej(new Error('Bild fehlt: ' + url))), { crossOrigin: 'anonymous' }));

    async function makeEditor(zone) {
      const wrap = document.createElement('div');
      wrap.className = 'anar-ed'; wrap.hidden = true;
      const cv = document.createElement('canvas');
      wrap.appendChild(cv); stageEl.appendChild(wrap);
      const c = new fabric.Canvas(cv, { width: W, height: H, preserveObjectStacking: true, selection: false, allowTouchScrolling: true });
      c.zone = zone;
      // Motive nur auf dem Stoff sichtbar: Maske des Produktfotos als Clip
      const mask = await loadImage(`${cfg.assetBase}anar-mask-${gKey}-${zone.img}.png?v=${PHOTO_VERSION}`);
      mask.set(Object.assign(photoTransform(zone, mask), { absolutePositioned: true }));
      c.clipShape = mask;
      c.region = { left: zone.region[0], top: zone.region[1], width: zone.region[2], height: zone.region[3] };
      c.on('after:render', () => drawGuide(c));
      ['object:moving', 'object:scaling', 'object:rotating'].forEach(ev => c.on(ev, e => { clamp(c, e.target); refresh(); }));
      c.on('object:modified', e => { clamp(c, e.target); refresh(); });
      c.on('selection:created', syncProps);
      c.on('selection:updated', syncProps);
      c.on('selection:cleared', syncProps);
      c.on('object:added', refresh);
      c.on('object:removed', refresh);
      eds[zone.id] = { c, wrap };
      setGarment(zone.id);
    }

    function setGarment(zoneId) {
      const { c } = eds[zoneId];
      const file = `${cfg.assetBase}anar-mock-${gKey}-${c.zone.img}-${colorFileKey(gKey, state.color)}.jpg?v=${PHOTO_VERSION}`;
      loadImage(file).then(img => {
        img.set(photoTransform(c.zone, img));
        c.setBackgroundImage(img, c.requestRenderAll.bind(c));
      }).catch(() => {});
    }

    function drawGuide(c) {
      if (exporting) return;
      const groups = groupsOf(c);
      if (!groups.length) return;
      const ctx = c.contextContainer, v = c.viewportTransform, z = c.getZoom();
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      groups.forEach((g, i) => {
        const col = g.tooBig ? '#C42C39' : ACCENT;
        ctx.lineWidth = 1.3 / z;
        ctx.setLineDash([5 / z, 4 / z]);
        ctx.strokeStyle = col;
        ctx.strokeRect(g.box.left - 3 / z, g.box.top - 3 / z, g.box.width + 6 / z, g.box.height + 6 / z);
        const label = g.tooBig ? `Druck ${i + 1} · zu groß` : `Druck ${i + 1} · ${cm1(g.w)}×${cm1(g.h)} cm · +${money(g.cents)}`;
        ctx.font = `600 ${10.5 / z}px sans-serif`;
        const tw = ctx.measureText(label).width, ph = 16 / z, px = 6 / z;
        let lx = g.box.left - 3 / z, ly = g.box.top - 3 / z - ph - 2 / z;
        if (ly < 2 / z) ly = g.box.top + g.box.height + 5 / z;
        lx = Math.max(2 / z, Math.min(lx, W - tw - 2 * px - 2 / z));
        ctx.setLineDash([]);
        ctx.fillStyle = col;
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(lx, ly, tw + 2 * px, ph, 8 / z); else ctx.rect(lx, ly, tw + 2 * px, ph);
        ctx.fill();
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText(label, lx + px, ly + ph - 4.5 / z);
      });
      ctx.restore();
    }

    function clamp(c, o) {
      if (!o) return;
      const r = c.region, Z = c.zone;
      o.setCoords();
      let b = o.getBoundingRect(true, true);
      const maxW = Z.maxCm ? Math.min(r.width, Z.maxCm.w * Z.pxPerCm) : r.width;
      const maxH = Z.maxCm ? Math.min(r.height, Z.maxCm.h * Z.pxPerCm) : r.height;
      if (b.width > maxW + 0.01 || b.height > maxH + 0.01) {
        const s = Math.min(maxW / b.width, maxH / b.height);
        o.scaleX *= s; o.scaleY *= s; o.setCoords();
        b = o.getBoundingRect(true, true);
      }
      let dx = 0, dy = 0;
      if (b.left < r.left) dx = r.left - b.left;
      if (b.left + b.width > r.left + r.width) dx = r.left + r.width - b.left - b.width;
      if (b.top < r.top) dy = r.top - b.top;
      if (b.top + b.height > r.top + r.height) dy = r.top + r.height - b.top - b.height;
      if (dx || dy) { o.left += dx; o.top += dy; o.setCoords(); }
    }

    function prep(c, o) {
      o.set({ originX: 'center', originY: 'center', clipPath: c.clipShape, lockScalingFlip: true, minScaleLimit: 0.01 });
      o.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });
      return o;
    }

    function fitZoom() {
      const avail = stageEl.clientWidth - 24;
      if (avail <= 0) return;
      const z = Math.max(0.4, Math.min(avail / W, 1.15));
      Object.values(eds).forEach(({ c }) => { c.setZoom(z); c.setDimensions({ width: W * z, height: H * z }); });
    }

    // ---------- Druck-Gruppen & Preis ----------
    function groupsOf(c) {
      const Z = c.zone, r = c.region, gap = GROUP_GAP_CM * Z.pxPerCm;
      const boxes = c.getObjects().map(o => {
        o.setCoords();
        const b = o.getBoundingRect(true, true);
        const l = Math.max(b.left, r.left), t = Math.max(b.top, r.top);
        const rr = Math.min(b.left + b.width, r.left + r.width), bb = Math.min(b.top + b.height, r.top + r.height);
        return { left: l, top: t, width: rr - l, height: bb - t };
      }).filter(b => b.width > 0.5 && b.height > 0.5);
      const near = (a, b) => a.left - gap <= b.left + b.width && b.left - gap <= a.left + a.width && a.top - gap <= b.top + b.height && b.top - gap <= a.top + a.height;
      const union = (a, b) => { const l = Math.min(a.left, b.left), t = Math.min(a.top, b.top); return { left: l, top: t, width: Math.max(a.left + a.width, b.left + b.width) - l, height: Math.max(a.top + a.height, b.top + b.height) - t }; };
      let merged = true;
      while (merged) {
        merged = false;
        outer: for (let i = 0; i < boxes.length; i++) for (let j = i + 1; j < boxes.length; j++) {
          if (near(boxes[i], boxes[j])) { boxes[i] = union(boxes[i], boxes[j]); boxes.splice(j, 1); merged = true; break outer; }
        }
      }
      boxes.sort((a, b) => a.top - b.top || a.left - b.left);
      return boxes.map(box => {
        const w = box.width / Z.pxPerCm, h = box.height / Z.pxPerCm;
        const big = Math.max(w, h) > SMALL_MAX_CM + 0.05;
        const tooBig = !!Z.maxCm && (w > Z.maxCm.w + 0.1 || h > Z.maxCm.h + 0.1);
        const units = big ? UNITS_LARGE : UNITS_SMALL;
        return { box, w, h, big, tooBig, units, cents: units * cfg.feeUnit, tier: big ? 'Groß' : 'Klein', pos: posText(Z, box) };
      });
    }
    function posText(Z, b) {
      const down = Math.max(0, (b.top - Z.refY) / Z.pxPerCm);
      const dx = (b.left + b.width / 2 - Z.midX) / Z.pxPerCm;
      const horiz = Math.abs(dx) < 0.5 ? 'mittig' : `Mitte ${cm1(Math.abs(dx))} cm ${dx < 0 ? 'links' : 'rechts'}`;
      return `${cm1(down)} cm unter ${Z.refLabel}, ${horiz}`;
    }
    const allGroups = () => ZONES.map(z => ({ zone: z, c: eds[z.id].c, groups: groupsOf(eds[z.id].c) }));
    const dpiOf = (c, o) => Math.round(2.54 * c.zone.pxPerCm / (o.scaleX / (o._anarRatio || 1)));
    const hasLowRes = () => ZONES.some(z => { const c = eds[z.id].c; return c.getObjects().some(o => o.type === 'image' && dpiOf(c, o) < 100); });

    function refresh() {
      const v = currentVariant();
      const all = allGroups();
      let total = v ? v.price : 0, lines = [], tooBig = false;
      all.forEach(({ zone, groups }) => {
        const sum = groups.reduce((t, g) => t + g.cents, 0);
        const el = root.querySelector(`[data-tier="${zone.id}"]`);
        if (el) { el.textContent = groups.length ? `+${money(sum)}` : 'leer'; el.classList.toggle('is-on', groups.length > 0); }
        groups.forEach((g, i) => {
          total += g.cents; tooBig = tooBig || g.tooBig;
          lines.push(`<div class="anar-line"><span>${zone.label}${groups.length > 1 ? ', Druck ' + (i + 1) : ''} · ${g.tier}</span><span>+${money(g.cents)}</span></div>`);
        });
      });
      const curZ = all.find(a => a.zone.id === state.zone), Z = curZ.zone;
      q('readout').innerHTML = curZ.groups.length
        ? `${Z.label}: <b>${curZ.groups.length} ${curZ.groups.length > 1 ? 'Drucke' : 'Druck'}</b> · ` + curZ.groups.map(g => `${cm1(g.w)}×${cm1(g.h)} cm`).join(', ')
        : `${Z.label}: noch leer`;
      q('area').textContent = Z.maxCm ? `Überall platzierbar · max. ${Z.maxCm.w} × ${Z.maxCm.h} cm je Druck` : 'Ganzer Ärmel bedruckbar';
      q('empty').hidden = curZ.c.getObjects().length > 0;
      q('base-label').textContent = [cfg.productTitle, state.color, state.size].filter(Boolean).join(', ');
      q('base').textContent = v ? money(v.price) : '–';
      q('lines').innerHTML = lines.length ? lines.join('') : '<div class="anar-line"><span>Noch kein Druck</span><span>–</span></div>';
      q('total').textContent = money(total);
      const warns = [];
      if (tooBig) warns.push('Ein Druck ist größer als die Pressenfläche. Verkleinere die Motive oder zieh sie weiter auseinander.');
      if (hasLowRes()) warns.push('Ein Foto ist für seine Druckgröße zu klein und wird unscharf. Verkleinere es oder lade eine größere Datei hoch.');
      q('warn').hidden = !warns.length;
      q('warn').innerHTML = `<span>${warns.join('<br>')}</span>`;
      q('zone-hint').innerHTML = `Wird auf <b>${Z.label}</b> eingefügt – danach überall hinschieben, auch ganz unten oder seitlich.`;
      const btn = q('add');
      if (!state.busy) {
        btn.disabled = !v || !v.available;
        btn.textContent = !v ? 'Bitte Größe wählen' : (v.available ? 'In den Warenkorb' : 'Ausverkauft');
      }
      const c = cur(), o = c.getActiveObject();
      if (o) {
        const bb = o.getBoundingRect(true, true);
        q('obj-size').textContent = `${cm1(bb.width / Z.pxPerCm)} × ${cm1(bb.height / Z.pxPerCm)} cm`;
        if (o.type === 'image') updateDpi(c, o);
      }
    }
    function updateDpi(c, o) {
      const d = dpiOf(c, o), el = q('dpi');
      if (d >= 150) { el.className = 'anar-badge is-good'; el.innerHTML = `<span><b>Gute Druckqualität</b> · ${d} DPI</span>`; }
      else if (d >= 100) { el.className = 'anar-badge is-warn'; el.innerHTML = `<span><b>Ausreichend</b> · ${d} DPI. Etwas kleiner wird es schärfer.</span>`; }
      else { el.className = 'anar-badge is-bad'; el.innerHTML = `<span><b>Zu unscharf für diese Größe</b> · ${d} DPI. Bitte verkleinern oder ein größeres Foto wählen.</span>`; }
    }

    // ---------- Panel ----------
    function syncProps() {
      const o = cur().getActiveObject();
      q('props-empty').hidden = !!o;
      q('props-common').hidden = !o;
      q('props-text').hidden = !(o && o.type === 'text');
      q('props-img').hidden = !(o && o.type === 'image');
      if (o && o.type === 'text') {
        if (q('txt').value !== o.text) q('txt').value = o.text;
        q('font').value = o.fontFamily;
        markSwatch('txt-colors', o.fill);
        markSwatch('stroke-colors', o.stroke || '#FFFFFF');
        setPressed('stroke', 'k', o.strokeKind || 'none');
        setPressed('align', 'a', o.textAlign);
      }
      refresh();
    }
    function setPressed(name, key, val) {
      q(name).querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset[key] === val)));
    }
    function markSwatch(name, hex) {
      q(name).querySelectorAll('.anar-sw').forEach(b => b.setAttribute('aria-pressed', String((b.dataset.hex || '').toLowerCase() === String(hex).toLowerCase())));
    }
    function swatchRow(name, list, onPick) {
      const el = q(name); el.innerHTML = '';
      list.forEach(([n, h]) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'anar-sw'; b.style.setProperty('--c', h); b.dataset.hex = h;
        b.setAttribute('aria-label', n); b.title = n; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', () => onPick(h));
        el.appendChild(b);
      });
      const cust = document.createElement('label');
      cust.className = 'anar-sw anar-sw--custom'; cust.title = 'Eigene Farbe';
      cust.innerHTML = '<input type="color" aria-label="Eigene Farbe">';
      cust.querySelector('input').addEventListener('input', e => onPick(e.target.value));
      el.appendChild(cust);
    }
    function withText(fn) {
      const c = cur(), o = c.getActiveObject();
      if (!o || o.type !== 'text') return;
      fn(o); clamp(c, o); c.requestRenderAll(); syncProps();
    }
    function applyStroke(o) {
      const k = o.strokeKind || 'none';
      o.set({ strokeWidth: k === 'none' ? 0 : o.fontSize * (k === 'thin' ? 0.05 : 0.11), stroke: k === 'none' ? null : (o.strokeHex || '#FFFFFF') });
    }

    function renderOptions() {
      const zt = q('zones'); zt.innerHTML = '';
      ZONES.forEach(z => {
        const b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'tab'); b.dataset.zone = z.id;
        b.innerHTML = `${z.label}<span class="anar-tier" data-tier="${z.id}">leer</span>`;
        b.addEventListener('click', () => { state.zone = z.id; showEditor(); });
        zt.appendChild(b);
      });
      const gc = q('garment-colors'); gc.innerHTML = '';
      q('color-row').hidden = colorIdx < 0;
      colors.forEach(col => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'anar-sw anar-sw--lg'; b.style.setProperty('--c', col.h);
        b.setAttribute('aria-label', col.n); b.title = col.n;
        b.setAttribute('aria-pressed', String(col.n === state.color));
        b.addEventListener('click', () => {
          state.color = col.n;
          gc.querySelectorAll('.anar-sw').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
          q('color-name').textContent = col.n;
          ZONES.forEach(z => setGarment(z.id));
          renderSizes(); refresh();
        });
        gc.appendChild(b);
      });
      q('color-name').textContent = state.color || '';
      renderSizes();
    }
    function renderSizes() {
      const ss = q('size');
      q('size-row').hidden = sizeIdx < 0;
      ss.innerHTML = '';
      sizes.forEach(s => {
        const v = cfg.variants.find(x => (colorIdx < 0 || x.options[colorIdx] === state.color) && x.options[sizeIdx] === s);
        const o = document.createElement('option');
        o.value = s; o.textContent = v && v.available ? s : `${s} – nicht verfügbar`;
        o.disabled = !v || !v.available;
        ss.appendChild(o);
      });
      ss.value = state.size;
    }
    function showEditor() {
      Object.entries(eds).forEach(([id, { c, wrap }]) => {
        const on = id === state.zone;
        wrap.hidden = !on;
        if (!on) c.discardActiveObject().requestRenderAll();
      });
      q('zones').querySelectorAll('button').forEach(b => b.setAttribute('aria-selected', String(b.dataset.zone === state.zone)));
      syncProps();
    }

    // ---------- Hinzufügen ----------
    function defaultSpot(c) {
      const Z = c.zone, r = c.region;
      const maxW = Z.maxCm ? Math.min(r.width, Z.maxCm.w * Z.pxPerCm) : r.width;
      return { x: Z.midX, y: Z.refY + r.height * (Z.maxCm ? 0.22 : 0.4), w: maxW * 0.6 };
    }
    function addText() {
      const c = cur(), spot = defaultSpot(c), fam = 'Montserrat';
      const t = prep(c, new fabric.Text('Dein Text', {
        fontFamily: fam, fontWeight: FONTS[fam], fontSize: 60, fill: colorObj().dark ? '#FFFFFF' : '#111111',
        textAlign: 'center', paintFirst: 'stroke', strokeLineJoin: 'round', lineHeight: 1.05,
        left: spot.x, top: spot.y
      }));
      t.set('fontSize', 60 * spot.w / t.width);
      c.add(t); clamp(c, t);
      c.setActiveObject(t); c.requestRenderAll(); syncProps();
      q('txt').focus(); q('txt').select();
    }
    function addImage(url) {
      const c = cur(), spot = defaultSpot(c), Z = c.zone;
      fabric.Image.fromURL(url, img => {
        if (!img || !img.width) { showStatus('Das Bild konnte nicht gelesen werden. Bitte eine JPG-, PNG- oder WEBP-Datei verwenden.'); return; }
        prep(c, img);
        useDisplayCopy(img);
        const maxH = Z.maxCm ? Z.maxCm.h * Z.pxPerCm * 0.6 : c.region.height * 0.5;
        const s = Math.min(spot.w / img.width, maxH / img.height);
        img.set({ scaleX: s, scaleY: s, left: spot.x, top: spot.y + img.height * s / 2 - 20 });
        c.add(img); clamp(c, img);
        c.setActiveObject(img); c.requestRenderAll(); syncProps();
      });
    }
    function showStatus(msg) { const s = q('status'); s.textContent = msg; s.hidden = !msg; }
    function handleFile(file) {
      showStatus('');
      if (!file) return;
      if (/heic|heif/i.test(file.type) || /\.hei[cf]$/i.test(file.name)) { showStatus('iPhone-Fotos im HEIC-Format werden nicht unterstützt. Bitte als JPG speichern oder einen Screenshot hochladen.'); return; }
      if (!/^image\/(png|jpe?g|webp)$/.test(file.type)) { showStatus('Diese Datei ist kein unterstütztes Bild. Bitte JPG, PNG oder WEBP hochladen.'); return; }
      if (file.size > 25 * 1024 * 1024) { showStatus('Die Datei ist größer als 25 MB. Bitte eine kleinere Datei wählen.'); return; }
      const r = new FileReader();
      r.onload = () => addImage(r.result);
      r.readAsDataURL(file);
    }

    // ---------- Export ----------
    function exportPreview(c, w) {
      exporting = true; c.discardActiveObject(); c.renderAll();
      const el = c.toCanvasElement(w / c.getWidth());
      exporting = false; c.requestRenderAll();
      return el;
    }
    function exportPrint(c, g, maxDpi) {
      const Z = c.zone, z = c.getZoom(), b = g.box;
      let dpi = maxDpi || 300; // gedeckelt auf ~16 MP (Grenze mobiler Browser)
      const px = (g.w / 2.54 * dpi) * (g.h / 2.54 * dpi);
      if (px > 16e6) dpi = Math.floor(dpi * Math.sqrt(16e6 / px));
      exporting = true; c.discardActiveObject();
      const bg = c.backgroundImage; c.backgroundImage = null;
      const lim = [fabric.perfLimitSizeTotal, fabric.maxCacheSideLimit];
      fabric.perfLimitSizeTotal = 1e9; fabric.maxCacheSideLimit = 20000; // sonst werden Fotos heruntergerechnet
      c.getObjects().forEach(o => { o.dirty = true; });
      const el = withFullRes(c, () => {
        c.getObjects().forEach(o => { o.dirty = true; });
        return c.toCanvasElement(((dpi / 2.54) / Z.pxPerCm) / z, { left: b.left * z, top: b.top * z, width: b.width * z, height: b.height * z });
      });
      fabric.perfLimitSizeTotal = lim[0]; fabric.maxCacheSideLimit = lim[1];
      c.getObjects().forEach(o => { o.dirty = true; });
      c.backgroundImage = bg; exporting = false; c.requestRenderAll();
      el.dpi = dpi;
      return el;
    }
    const toBlob = el => new Promise((res, rej) => el.toBlob(b => b ? res(b) : rej(new Error('PNG konnte nicht erstellt werden')), 'image/png'));
    // Shopify nimmt pro Warenkorb-Anfrage höchstens ~20 MB an: Auflösung senken, bis die Datei passt
    const MAX_UPLOAD = 18.5 * 1048576;
    async function printBlob(c, g) {
      let dpi = 300;
      for (;;) {
        const el = exportPrint(c, g, dpi);
        const blob = await toBlob(el);
        if (blob.size <= MAX_UPLOAD || el.dpi <= 100) return { blob, dpi: el.dpi, w: el.width, h: el.height };
        dpi = Math.max(100, Math.floor(el.dpi * Math.sqrt(MAX_UPLOAD / blob.size) * 0.95));
      }
    }
    async function cartPost(url, body) {
      const isForm = body instanceof FormData;
      const r = await fetch(cfg.root + url, {
        method: 'POST', body: isForm ? body : JSON.stringify(body),
        headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(r.status === 413 ? 'Datei zu groß' : (j.description || j.message || 'Fehler beim Warenkorb'));
      return j;
    }

    async function addToCart() {
      const v = currentVariant();
      const used = allGroups().filter(a => a.groups.length);
      if (!v || !v.available) return;
      if (!used.length) { showStatus('Füge zuerst ein Foto oder einen Text hinzu.'); return; }
      if (used.some(a => a.groups.some(g => g.tooBig))) { showStatus('Ein Druck ist zu groß. Bitte Motive verkleinern oder weiter auseinanderziehen.'); return; }
      if (!cfg.feeVariant) { showStatus('Der Druck-Aufpreis ist im Shop noch nicht eingerichtet. Bitte später erneut versuchen.'); return; }
      showStatus('');
      const btn = q('add');
      state.busy = true; btn.disabled = true; btn.textContent = 'Druckdateien werden erstellt …';
      await new Promise(r => setTimeout(r, 50));
      // Aufbau im Warenkorb:
      //  1 Zeile gestalteter Artikel (Vorschau, Design-Nr.)
      //  + 1 Zeile Druck-Aufpreis pro Druck, mit Druckdatei, Maßen und Position (je Anfrage < 20 MB)
      const added = [];
      try {
        const designId = 'D' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase();
        const prints = [];
        used.forEach(({ zone, c, groups }) => groups.forEach((g, i) => prints.push({ zone, c, g, name: `${zone.label}${groups.length > 1 ? ' Druck ' + (i + 1) : ''}` })));

        const first = used.find(a => a.zone.id === 'front') || used[0];
        const main = new FormData();
        main.append('id', v.id);
        main.append('quantity', '1');
        main.append('properties[Design-Nr.]', designId);
        main.append('properties[Drucke]', prints.map(p => `${p.name} (${p.g.tier})`).join(', '));
        main.append('properties[_Vorschau]', await toBlob(exportPreview(first.c, 600)), `${designId}-vorschau.png`);
        main.append('properties[_design]', designId);
        main.append('properties[_designer]', '1');
        btn.textContent = 'Wird hochgeladen …';
        const mainItem = await cartPost('cart/add.js', main);
        added.push(mainItem.key);

        for (let n = 0; n < prints.length; n++) {
          const { zone, c, g, name } = prints[n];
          btn.textContent = `Druckdatei ${n + 1} von ${prints.length} …`;
          const file = await printBlob(c, g);
          const fd = new FormData();
          fd.append('id', cfg.feeVariant);
          fd.append('quantity', String(g.units));
          fd.append('properties[Druck]', `${name} · ${g.tier} · ${cm1(g.w)} x ${cm1(g.h)} cm · ${g.pos}`);
          fd.append('properties[Druckdatei]', file.blob, `${designId}-${zone.id}-${n + 1}.png`);
          fd.append('properties[Für]', `${cfg.productTitle} (${designId})`);
          fd.append('properties[_design]', designId);
          fd.append('properties[_einheiten]', String(g.units));
          fd.append('properties[_dpi]', String(file.dpi));
          const feeItem = await cartPost('cart/add.js', fd);
          added.push(feeItem.key);
        }
        window.location.href = cfg.cartUrl;
      } catch (err) {
        // halb hinzugefügte Zeilen wieder entfernen
        if (added.length) {
          const updates = {}; added.forEach(k => { updates[k] = 0; });
          await cartPost('cart/update.js', { updates }).catch(() => {});
        }
        state.busy = false;
        showStatus(`Das hat nicht geklappt: ${err.message}. Bitte erneut versuchen.`);
        refresh();
      }
    }

    // ---------- Bedienung ----------
    q('upload').addEventListener('click', () => q('file').click());
    q('file').addEventListener('change', e => { handleFile(e.target.files[0]); e.target.value = ''; });
    q('text').addEventListener('click', addText);
    q('add').addEventListener('click', addToCart);
    q('size').addEventListener('change', e => { state.size = e.target.value; refresh(); });

    const fs = q('font');
    Object.keys(FONTS).forEach(f => { const o = document.createElement('option'); o.value = o.textContent = f; o.style.fontFamily = `"${f}"`; fs.appendChild(o); });
    fs.addEventListener('change', e => withText(o => { o.set({ fontFamily: e.target.value, fontWeight: FONTS[e.target.value] }); applyStroke(o); }));
    q('txt').addEventListener('input', e => withText(o => o.set('text', e.target.value)));
    swatchRow('txt-colors', TEXT_COLORS, h => withText(o => o.set('fill', h)));
    swatchRow('stroke-colors', [['Weiß', '#FFFFFF'], ['Schwarz', '#111111'], ['Rosa', '#F49AC2'], ['Gold', '#C9A227']], h => withText(o => { o.strokeHex = h; if (!o.strokeKind || o.strokeKind === 'none') o.strokeKind = 'thin'; applyStroke(o); }));
    q('stroke').querySelectorAll('button').forEach(b => b.addEventListener('click', () => withText(o => { o.strokeKind = b.dataset.k; applyStroke(o); })));
    q('align').querySelectorAll('button').forEach(b => b.addEventListener('click', () => withText(o => o.set('textAlign', b.dataset.a))));

    root.querySelectorAll('[data-act]').forEach(b => b.addEventListener('click', () => {
      const c = cur(), o = c.getActiveObject();
      if (!o) return;
      const act = b.dataset.act;
      if (act === 'center') o.set({ left: c.zone.midX });
      if (act === 'up') c.bringForward(o);
      if (act === 'down') c.sendBackwards(o);
      if (act === 'flip') o.set('flipX', !o.flipX);
      if (act === 'del') { c.remove(o); c.discardActiveObject(); c.requestRenderAll(); syncProps(); return; }
      if (act === 'dup') {
        o.clone(cl => {
          prep(c, cl); cl.set({ left: o.left + 10, top: o.top + 10, strokeKind: o.strokeKind, strokeHex: o.strokeHex });
          if (o._anarFull) { cl._anarFull = o._anarFull; cl._anarRatio = o._anarRatio; }
          c.add(cl); clamp(c, cl); c.setActiveObject(cl); c.requestRenderAll(); syncProps();
        });
        return;
      }
      o.setCoords(); clamp(c, o); c.requestRenderAll(); refresh();
    }));

    document.addEventListener('keydown', e => {
      if (e.key !== 'Delete' && e.key !== 'Backspace') return;
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName) || document.activeElement.isContentEditable) return;
      const c = cur(), o = c.getActiveObject();
      if (o) { e.preventDefault(); c.remove(o); c.discardActiveObject(); c.requestRenderAll(); syncProps(); }
    });

    let dragDepth = 0;
    const drop = q('drop');
    stageEl.addEventListener('dragenter', e => { e.preventDefault(); dragDepth++; stageEl.classList.add('is-drag'); drop.hidden = false; });
    stageEl.addEventListener('dragover', e => e.preventDefault());
    stageEl.addEventListener('dragleave', () => { if (--dragDepth <= 0) { dragDepth = 0; stageEl.classList.remove('is-drag'); drop.hidden = true; } });
    stageEl.addEventListener('drop', e => { e.preventDefault(); dragDepth = 0; stageEl.classList.remove('is-drag'); drop.hidden = true; handleFile(e.dataTransfer.files[0]); });

    // ---------- Start ----------
    const tools = [q('upload'), q('text'), q('add')];
    tools.forEach(b => { b.disabled = true; });
    q('empty').firstElementChild.textContent = 'Wird geladen …';
    try {
      await Promise.all(ZONES.map(makeEditor));
    } catch (err) {
      q('empty').firstElementChild.textContent = 'Die Produktbilder konnten nicht geladen werden. Bitte Seite neu laden.';
      return;
    }
    q('empty').firstElementChild.textContent = 'Foto hochladen oder Text hinzufügen';
    tools.forEach(b => { b.disabled = false; });
    renderOptions();
    fitZoom();
    new ResizeObserver(fitZoom).observe(stageEl);
    showEditor();
    Promise.race([
      Promise.all(Object.entries(FONTS).map(([f, w]) => document.fonts.load(`${w} 40px "${f}"`))),
      new Promise(r => setTimeout(r, 4000))
    ]).catch(() => {}).then(() => Object.values(eds).forEach(({ c }) => c.requestRenderAll()));
  }

  function boot() { document.querySelectorAll('[data-anar-designer]').forEach(initDesigner); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
